export type Position = { x: number; y: number };

export type BoundingBox = {
    left: number;
    right: number;
    top: number;
    bottom: number;
};

export function boundingBoxContains(
    box: BoundingBox,
    position: Position
): boolean {
    return (
        box.left <= position.x &&
        box.right >= position.x &&
        box.top <= position.y &&
        box.bottom >= position.y
    );
}
